<!--
  File name: PDBNFDetails.vue
  Program Description:
    - This component contains the design for the Personal Data Breach Notification
    Details export
    - When accessed, it renders the values passed from the parent component and
    assigns the values to be passed on the child components (Form Row)
  Includes:
    * FormRow
-->

<template>
  <v-container>
    <v-row
      class="pa-0 ma-0 padd"
      style="margin-top: 15px"
    >
      <h2
        class="font primary marginBot"
        style="font-size: 20px;"
      >
        Personal Data Breach Notification Details
      </h2>
    </v-row>
    <FormRow
      :fields="[
        {
          label: 'Sector Name',
          value: notif.sector
        },
        {
          label: 'Sub Sector Name',
          value: notif.subSector
        }
      ]"
    />
    <FormRow
      :fields="[
        {
          label: 'Notification Type',
          value: notif.notification
        },
        {
          label: 'Timeliness',
          value: notif.timeliness
        }
      ]"
    />
    <FormRow
      :fields="[
        {
          label: 'Justified, if Delayed',
          value: notif.justified
        },
        {
          label: 'General Cause',
          value: notif.generalCause
        }
      ]"
    />
    <FormRow
      :fields="notif.specificCause === 'Others' ? [
        {
          label: 'Specific Cause',
          value: notif.specificCause
        },
        {
          label: 'Remarks',
          value: notif.specificCauseOthers
        }
      ] : [
        {
          label: 'Specific Cause',
          value: notif.specificCause
        },
        {}
      ]"
    />
    <span>
      <v-row
        class="pa-0 ma-0 padd"
        style="margin-top: 20px"
      >
        <h2
          class="font primary marginBot"
          style="font-size: 20px; padding: 10px 0px"
        >
          With Request
        </h2>
      </v-row>
      <v-row
        v-if="notif.typeOfRequest.includes('Request for extension')"
        class="font padd"
        style="margin-bottom: 30px"
      >
        <v-col>
          <v-row style="margin-bottom: 5px">
            <p class="parimary">
              Request for extension
            </p>
          </v-row>
          <v-row
            class="font size padd"
            style="margin-top: 10px; margin-left: 20px"
          >
            Days: {{ notif.extensionDays }}
          </v-row>
          <v-row
            class="font size padd"
            style="margin-left: 20px"
          >
            <v-col>
              <v-row style="margin-bottom: 5px">
                <p>
                  Explain why extension is requested and specify documents that needs extension
                </p>
              </v-row>
              <v-row class="pa-0 ma-0">
                <v-col style="border: 0.1px solid #454545;">
                  {{ notif.requestExtension }}
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </span>
    <!-- Request for exemption -->
    <v-row
      v-if="notif.typeOfRequest.includes('Request for exemption')"
      class="font padd"
      style="margin-bottom: 20px"
    >
      <v-col>
        <v-row style="margin-bottom: 5px">
          <p class="parimary">
            Request for exemption
          </p>
        </v-row>
        <v-row
          class="font size padd"
          style="margin-left: 20px"
        >
          <v-col>
            <v-row style="margin-bottom: 5px">
              <p>
                Justification for exemption
              </p>
            </v-row>
            <v-row class="pa-0 ma-0">
              <v-col style="border: 0.1px solid #454545;">
                {{ notif.justificationExemption }}
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!-- Request for postpone -->
    <v-row
      v-if="notif.typeOfRequest.includes('Request for postponement')"
      class="font padd"
      style="margin-bottom: 20px"
    >
      <v-col>
        <v-row style="margin-bottom: 5px">
          <p class="parimary">
            Request for postponement
          </p>
        </v-row>
        <v-row
          class="font size padd"
          style="margin-left: 20px"
        >
          <v-col>
            <v-row style="margin-bottom: 5px">
              <p>
                Justification for postponement
              </p>
            </v-row>
            <v-row class="pa-0 ma-0">
              <v-col style="border: 0.1px solid #454545;">
                {{ notif.justificationPostponement }}
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!-- Request for alternative means of notification -->
    <v-row
      v-if="notif.typeOfRequest.includes('Request for alternative means of notification')"
      class="font padd"
      style="margin-bottom: 20px"
    >
      <v-col>
        <v-row style="margin-bottom: 5px">
          <p class="parimary">
            Request for alternative means of notification
          </p>
        </v-row>
        <v-row
          class="font size padd"
          style="margin-left: 20px"
        >
          <v-col>
            <v-row style="margin-bottom: 5px">
              <p>
                Justification for alternative means of notification
              </p>
            </v-row>
            <v-row class="pa-0 ma-0">
              <v-col style="border: 0.1px solid #454545;">
                {{ notif.justificationAlternative }}
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!-- Others -->
    <v-row
      v-if="notif.typeOfRequest.includes('Others')"
      class="font padd"
      style="margin-bottom: 20px"
    >
      <v-col>
        <v-row style="margin-bottom: 5px">
          <p class="parimary">
            Others
          </p>
        </v-row>
        <v-row
          class="font size padd"
          style="margin-left: 20px"
        >
          Specify Others: {{ notif.typeOfRequestOther }}
        </v-row>
        <v-row
          class="font size padd"
          style="margin-left: 20px"
        >
          <v-col>
            <v-row style="margin-bottom: 5px">
              <p>
                Justification for others
              </p>
            </v-row>
            <v-row class="pa-0 ma-0">
              <v-col style="border: 0.1px solid #454545;">
                {{ notif.justificationOthers }}
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="font size padd">
      <v-col>
        <v-row style="margin-bottom: 5px">
          <p>
            Possible Violation of the DPA
          </p>
        </v-row>
        <v-row class="pa-0 ma-0">
          <v-col style="border: 0.1px solid #454545; padding-bottom: 30px">
            {{ notif.possibleViolation }}
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row
      v-for="(item, key) in listItems"
      :key="key"
      class="font size padd"
    >
      <v-col>
        <v-row style="margin-top: 5px; margin-bottom: 5px">
          <b>{{ item.label }}</b>
        </v-row>
        <v-row class="pa-0 ma-0">
          <v-col
            cols="3"
            style="padding: 0px; padding-bottom: 3px"
          >
            Sufficiently Provided
          </v-col>
          <v-col
            cols="9"
            style="padding: 0px; padding-bottom: 3px"
          >
            Provide Details
          </v-col>
        </v-row>
        <v-row class="pa-0 ma-0">
          <v-col
            cols="3"
            style="border: 0.1px solid #454545; border-right: none"
          >
            {{ notif[`${item.details}Provided`] }}
          </v-col>
          <v-col
            cols="9"
            style="border: 0.1px solid #454545"
          >
            {{ notif[item.details] }}
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row
      class="font size padd"
      style="padding-top: 15px"
    >
      Record Type: {{ notif.recordType }}
    </v-row>
  </v-container>
</template>

<script>
import FormRow from './FormRow.vue'

export default {
  components: {
    FormRow
  },
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  computed: {
    notif () {
      if (!this.$props.data) return {}
      const { sector, subsector, sectorOpts, justified, causeOpts, generalCause, specificCause, recordOpts, recordType } = this.$props.data

      const sectorInfo = sectorOpts.find(x => x._id === (sector._id || sector))
      const subSec = sectorInfo.subsector.find(y => y._id === (subsector._id || subsector))

      const general = causeOpts.find(w => w._id === (generalCause._id || generalCause))
      let specific = specificCause
      if (specificCause !== 'Others') {
        const info = causeOpts.find(s => s._id === (specificCause._id || specificCause))
        specific = info ? info.value : specific
      }

      const rType = recordOpts.find(r => r._id === (recordType._id || recordType))

      return {
        ...this.$props.data,
        sector: sectorInfo ? sectorInfo.value : '',
        subSector: subSec ? subSec.value : '',
        justified: justified || '',
        generalCause: general.value,
        specificCause: specific,
        recordType: rType ? rType.value : recordType
      }
    },
    listItems () {
      return [
        {
          label: '1.a How breach occurred + DPS vulnerability',
          details: 'howBreachOccurred'
        },
        {
          label: '1.b Chronology',
          details: 'chronology'
        },
        {
          label: '1.c Number of DS / Records',
          details: 'numberOfDataSubjects'
        },
        {
          label: '1.d Description / Nature',
          details: 'descriptionOrNature'
        },
        {
          label: '1.e Likely Consequences',
          details: 'likelyConsequences'
        },
        {
          label: '1.f DPO',
          details: 'dataProtectionOfficer'
        },
        {
          label: '2.a SPI',
          details: 'sensitivePersonalInformation'
        },
        {
          label: '2.b Other info that may enable identity fraud',
          details: 'identityFraud'
        },
        {
          label: '3.a Measures to address the breach',
          details: 'measuresToAddress'
        },
        {
          label: '3.b Measures to secure/recover personal data?',
          details: 'measuresToSecure'
        },
        {
          label: '3.c Actions to mitigate harm?',
          details: 'actionsToMitigateHarm'
        },
        {
          label: '3.d Actions to inform data subjects?',
          details: 'actionsToInformDataSubjects'
        },
        {
          label: '3.e Measures to prevent recurrence of incidence',
          details: 'measuresToPreventRecurrence'
        }
      ]
    }
  }
}
</script>

<style scoped>
  .font {
    font-family: 'Source Sans Pro';
  }
  .primary {
    color: #383c74
  }
  .padd {
    padding-left: 3px;
  }
  .size {
    font-size: 13px;
  }
  .marginBot {
    margin: 0px 0px 10px 0px;
  }
</style>
